import React from 'react';
import * as R from 'ramda';
import clsx from 'clsx';
import { Grid, TextField as MUITextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Field, TextField } from 'src/app-builder';
import { MetricValue, User as UserType } from 'src/graphql';

import { UserComment } from './UserComment';
import {
  isNegative,
  subtractNumbers,
  getFormattedMetricValue,
  convertFromFormData,
} from 'src/utils';
import { Format } from 'src/constants';

interface BodyProps {
  format: Format;
  cell: MetricValue | null;
  values: {
    originalValue: number;
    adjustedValue: number;
    adjustmentValue: number;
    comment: string;
  };
  submitting: boolean;
  onClose: () => void;
}

const useStyles = makeStyles(() => ({
  lessThanZero: {
    '& .MuiInputBase-input': {
      color: '#eb4336',
    },
  },
}));

export const Body: React.FC<BodyProps> = ({
  cell,
  format,
  values: { originalValue, adjustedValue },
  submitting,
}) => {
  const classes = useStyles();

  const user: UserType = R.pathOr({}, ['createdBy'], cell);

  const comment = R.pathOr('', ['comment'], cell);

  const adjustment = subtractNumbers(adjustedValue, originalValue);

  const {
    originalValue: convertedOriginalValue,
    adjustment: convertedAdjustmentValue,
  } = convertFromFormData({ originalValue, adjustment }, format);

  return (
    <Grid container item spacing={2}>
      <Grid item xs={12}>
        <MUITextField
          className={clsx({
            [classes.lessThanZero]: isNegative(originalValue),
          })}
          label="Original value"
          value={getFormattedMetricValue(convertedOriginalValue, format)}
          size="small"
          variant="outlined"
          disabled
          fullWidth
        />
      </Grid>

      <Grid item xs={12}>
        <MUITextField
          className={clsx({
            [classes.lessThanZero]: isNegative(adjustment),
          })}
          label="Adjustment"
          value={getFormattedMetricValue(convertedAdjustmentValue || 0, format)}
          defaultValue={0}
          size="small"
          variant="outlined"
          disabled
          fullWidth
        />
      </Grid>

      <Grid item xs={12}>
        <Field
          component={TextField}
          name="comment"
          label="Add comment"
          disabled={submitting}
          size="small"
          fullWidth
        />
      </Grid>

      <UserComment user={user} comment={comment} />
    </Grid>
  );
};
